import { IconHighway16, Image, UIText2 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';
import classNames from 'classnames';
import * as React from 'react';

import { IRecommendedVillage } from 'shared/types/recommendedVillages';

import * as styles from './VillageItem.css';
import { Link } from '../../../Link';

interface IVillageItemProps extends IRecommendedVillage {
  onClick(): void;
}

export const VillageItem: React.VFC<IVillageItemProps> = ({
  imageUrl,
  landSquareUnits,
  minArea,
  minPrice,
  roadInfo,
  squareUnits,
  minLandArea,
  url,
  villageTitle,
  onClick,
}) => {
  const villageSquareInfo = React.useMemo(
    () =>
      [minArea && `от ${minArea} ${squareUnits}`, minLandArea && `от ${minLandArea} ${landSquareUnits}`]
        .filter(Boolean)
        .join(' ･ '),
    [minArea, squareUnits, minLandArea, landSquareUnits],
  );

  return (
    <Link url={url} linkStyle={styles['link']} onClick={onClick} target="_blank">
      <Image src={imageUrl} objectFit="cover" width="100%" height={140} />
      <div className={styles['info']}>
        <div className={styles['row']}>
          <UIText2 fontWeight="bold">{villageTitle}</UIText2>
        </div>
        <div className={styles['row']}>
          <UIText2>от {numberToPrettyString(minPrice)} ₽</UIText2>
        </div>
        <div className={styles['row']}>
          <UIText2>{villageSquareInfo}</UIText2>
        </div>
        {roadInfo && (
          <div className={classNames(styles['location-container'], styles['row'])}>
            <div className={styles['highway-icon']}>
              <IconHighway16 />
            </div>
            <UIText2>{roadInfo?.name}</UIText2>
          </div>
        )}
      </div>
    </Link>
  );
};
